

// Use this if you need dates in format "Jul 2, 2019"
export const renderDayShort = (selectedDay) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric'};
    return renderDay(selectedDay, options);
};

// USe if you need dates in format "June 19, 2019, 11:58 AM EDT"
export const renderDayLong = (selectedDay) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour12: true, hour: 'numeric', minute: 'numeric', timeZoneName: 'short' };
    return renderDay(selectedDay, options);
};

const renderDay = (selectedDay, options) => {
    // This is so cool! I don't mind "dating" JS anymore :D
    // Need to specify timezone in order to get correct date. Abstract shows library page should always show dates in EST, hence passing the Eastern time hardcoded here.
    // Fix for RangeError in firefox: Convert the date into UTC string first and then pass timezone you want. new Date('1-1-2019 EDT') works for chrome but not for firefox
    // Fix for safari: remove the .0 from date string we are getting from backend
    return new Intl.DateTimeFormat('en-US', options).format(new Date(Date.parse(selectedDay.replace(/-/g, "/").replace(/\.0/g," "))));
};